// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__22vHX","containerItemsCenter":"Skeleton_containerItemsCenter__3jdUB"};